import React from "react";

type ChildHrefNavigationBlockerProps = {
    children: React.ReactNode;
    onClick: () => void;
};

/**
 * Context: for SEO purposes, we might want some components to be `links` (children) and have and `href`,
 * but we don't want to use that `href` to navigate, instead, we want to use custom logic (onClick).
 * This component is a wrapper that prevents the default behavior of the `href` and stops the propagation of the event.
 */

const ChildHrefNavigationBlocker = ({ children, onClick }: ChildHrefNavigationBlockerProps) => {
    return (
        <div
            onClickCapture={event => {
                event.stopPropagation();
                event.preventDefault();
                onClick();
            }}>
            {children}
        </div>
    );
};

export default ChildHrefNavigationBlocker;
